import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Divider, Typography } from '@mui/material';
import ArrowRight from "@mui/icons-material/ArrowRight";

import styles from "./styles";

const SelectionDialog = ({ isOpen, onTypeSelected, onCancelPressed }) => {

  const classes = styles();

  const _onTypeSelected = (value) => {
    onTypeSelected(value);
  };

  return (
    <Dialog open={isOpen} onClose={onCancelPressed}>
      <Typography color='primary' variant='h6' style={{ padding: 20 }}>Select Type</Typography>
      <DialogContent style={{ width: 500 }}>
        <div className={classes.item} onClick={() => _onTypeSelected("ADD COUPON")}>
          <div>
            <Typography variant='body1'>{"Add Coupon"}</Typography>
            <Typography variant='caption'>{"Proceed to add coupon"}</Typography>
          </div>
          <ArrowRight />
        </div>
        <div className={classes.item} onClick={() => _onTypeSelected("ADD COMBINATION DISCOUNT")}>
          <div>
            <Typography variant='body1'>{"Add Combination Discount"}</Typography>
            <Typography variant='caption'>{"Proceed to add combination discount"}</Typography>
          </div>
          <ArrowRight />
        </div>
   
      </DialogContent>
      <DialogActions className={classes.modalActions}>
        <Button onClick={onCancelPressed} color="primary">Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}

export default SelectionDialog;